async function dovrSettings() {
  try {
    var dovrSettings = window.dovr;
    var data = await fetch("{{ 'dovr.json' | asset_url }}");
    return await data.json();
  } catch (e) {
    console.error(e);
  }
}

dovrSettings();

function viewProduct(url) {
  window.location.href = url;
}

async function addAllItemsToCart(products) {
  try {
    for (var product of products) {
      await addProductToCart(product.variant_id);
    }
  } catch (e) {
    console.log(e);
  } finally {
    location.reload();
  }
}

function addAllItemsToCartListener(
  products,
  selected_collection_handle,
  image_type = "holistic"
) {
  document
    .querySelector(
      `.collection--${selected_collection_handle}.${image_type} .add-all-button`
    )
    .addEventListener("click", function () {
      addAllItemsToCart(products);
    });
}

async function addProductToCart(variant_id, reload = false) {
  // Define the product variant ID and quantity

  try {
    var variantId = variant_id;
    var quantity = 1;

    // Construct the request URL
    var url = "/cart/add.js";
    var data = {
      id: variantId,
      quantity: quantity,
    };

    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    console.log(`${variant_id} added to cart!`);
    if (reload) {
      location.href = "/cart";
    }
  } catch (e) {
    console.error(e);
  }
}

function addDescription(collection, section_id) {
  document.querySelector(
    `#room-suite---${section_id} .shoppable-section-text`
  ).innerHTML = collection.description;
}

function addShoppableImageSrc(
  data,
  selected_collection_handle,
  image_type = "holistic"
) {
  var sizes = ["desktop", "mobile"];
  for (var size of sizes) {
    var img = document.querySelector(
      `.collection--${selected_collection_handle}.${image_type} .shoppable-image.${size}`
    );
    img.src = data.images[image_type][size];
    img.alt = data.name;
  }
}

async function renderHotSpots(
  products,
  selected_collection,
  selected_collection_handle,
  image_type = "holistic"
) {
  var parent = document.querySelector(
    `.collection--${selected_collection_handle}.${image_type} .shoppable-image-placeholder`
  );
  var productsJSONData = [];

  for (var i = 0; i < products.length; i++) {
    var index = i + 1;
    var product = products[i];
    var html = popupCardHTML(product, index);
    parent.insertAdjacentHTML("afterend", html);
    dotProductEventHandlers(product.handle, selected_collection_handle, image_type);

    //Need to setup the click for adding all items to cart
    productsJSONData.push(product);
  }

  //Add Click handler for adding all items to cart
  addAllItemsToCartListener(
    productsJSONData,
    selected_collection_handle,
    image_type
  );
}

async function requestProductInfo(product) {
  try {
    var data = await fetch(`/products/${product.handle}.json`);
    data = await data.json();

    var info = {};

    //Map info
    info.title = data.product.title;
    info.vendor = data.product.vendor;
    info.handle = data.product.handle;
    info.tags = data.product.tags;
    info.sku = product.sku;
    info.image = data.product.image.src;
    info.alt = data.product.image.alt;
    info.image_height = data.product.image.height;
    info.image_width = data.product.image.width;
    info.hotspots = product.hotspots;

    //Find matching variant sku
    for (var variant of data.product.variants) {
      if (variant.sku === product.sku) {
        info.variant_id = variant.id;
        info.price = variant.price;
        info.compare_at_price = variant.compare_at_price;
        info.sku = variant.sku;

        //Find matching variant image
        if (variant.image_id !== null) {
          for (var image of data.product.images) {
            if (image.id === variant.image_id) {
              info.image = image.src;
              info.image_height = image.height;
              info.image_width = image.width;
              break;
            }
          }
        }
        break;
      }
    }

    return info;
  } catch (e) {
    console.error(e);
  }
}

//Regex to handelize string for URL
function handelize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
}

function variantURL(product) {
  return `/products/${product.handle}?variant=${product.variant_id}`;
}

function popupCardHTML(data, index) {
  console.log(data);
  var handelizedVendor = handelize(data.vendor);
  var url = variantURL(data);
  return `
    <div class="popup popup-container popup-product-${data.handle} hidden animate__animated animate__fadeIn">
      <div class="popup popup-wrapper">
        <div class="popup popup-thumbnail-container">
          <div class="popup product-thumbnail-wrapper">
            <div class="popup product-thumbnail-ratio">
              <img src="${data.image}" class="popup product-thumbnail" alt="${data.alt}">
            </div>
          </div>
        </div>
        <div class="popup popup-content">
         <div class="popup popup-header">
            <span class="popup popup-header-title">${data.title}</span>
            <span class="popup popup-header-vendor">
              <a href="/collections/vendors?q=${handelizedVendor}">${data.vendor}</a>
            </span>
            <span class="popup popup-header-sku">SKU: ${data.sku}</span>
            <span class="popup popup-header-price">\$${data.price}</span>
          </div>
          <button class="popup popup-button popup-atc-button" onclick="addProductToCart('${data.variant_id}', true)" data-sku="${data.sku}">Add To Cart</button>
          <button class="popup popup-button popup-view-button" onclick="viewProduct('${url}')">View</button>
        </div>
      </div>
    </div>
    <!-- Hotspot dot --> 
    <div class="dot dot-${data.handle} glow animate__animated animate__fadeIn">${data.handle}</div>
    `;
}

// //Render X & Y coordinates for hotspots with <style> tags
function renderStyleSheetCoordinates(
  collections,
  selected_collection,
  selected_collection_handle
) {
  var rules = {
    desktop: [],
    mobile: [],
  };

  //Reposition the x coordinate if it falls outside of the threshold of viewing - (popup card overflows/overlaps if its too far out)
  function positionXCoordinate(coordinate) {
    if (coordinate >= 80) {
      return coordinate - 25;
    } else {
      return coordinate;
    }
  }

  for (var collection of collections) {
    if (collection.name === selected_collection) {
      for (var i = 0; i < collection.products.length; i++) {
        // var index = i + 1;
        var product = collection.products[i];

        var classSelectors = {
          desktop: [],
          mobile: [],
        };

        for (var image_type of Object.keys(product.hotspots)) {
          console.log(product);
          //Only one image: blown_out.
          if(image_type === "blown_out"){
            //Desktop coordinates
            var x_desktop = product.hotspots[image_type].desktop.x_coordinate;
            var y_desktop = product.hotspots[image_type].desktop.y_coordinate;
  
            //Mobile coordinates
            var x_mobile = product.hotspots[image_type].mobile.x_coordinate;
            var y_mobile = product.hotspots[image_type].mobile.y_coordinate;
  
            //Desktop selectors
            var desktopSelector = `
            .collection--${selected_collection_handle}.${image_type} .dot-${product.handle} {
                top: ${y_desktop}%;
                right: ${x_desktop}%;
            }
  
            .collection--${selected_collection_handle}.${image_type} .popup-product-${product.handle} {
                background: #fff;
                top: ${y_desktop}%;
                right: ${positionXCoordinate(x_desktop)}%;
            }
            `;
            classSelectors.desktop.push(desktopSelector);
  
            //Mobile selectors
            var mobileSelector = `
            .collection--${selected_collection_handle}.${image_type} .dot-${product.handle} {
                background: #fff;
                top: ${y_mobile}%;
                right: ${x_mobile}%;
            }
  
            .collection--${selected_collection_handle}.${image_type} .popup-product-${product.handle} {
                background: #fff;
                top: ${y_mobile}%;
                right: ${positionXCoordinate(x_mobile)}%;
            }
            `;
  
            classSelectors.mobile.push(mobileSelector);
          }
        }

        rules.desktop.push(classSelectors.desktop.join("\n"));
        rules.mobile.push(classSelectors.mobile.join("\n"));
      }
      break;
    }
  }

  var html = `
    <style>
      /* Desktop coordinates */
      ${rules.desktop.join("\n")}

      /* Mobile coordinates */
      @media screen and (max-width: 700px) {
      ${rules.mobile.join("\n")}
      }
    </style>
  `;
  document
    .querySelector(
      `.dovr-shoppable-section.collection--${selected_collection_handle}.${image_type}`
    )
    .insertAdjacentHTML("afterend", html);
}

//Mouse hovering effects
function reactToMouse(
  event,
  data,
  selected_collection_handle,
  image_type = "holistic"
) {
  var dots = [];

  for (var i = 0; i < data.length; i++) {
    const handle = data[i].handle;
    dots.push(
      `.collection--${selected_collection_handle}.${image_type} .dot-${handle}`
    );
  }

  for (var dot of dots) {
    var element = document.querySelector(dot);
    var rect = element.getBoundingClientRect();
    var mouseX = event.clientX;
    var mouseY = event.clientY;
    var distance = calculateDistance(rect, mouseX, mouseY);

    var scaleFactor = 1 + (1 - distance / 100); // Adjust the scaling factor as desired
    if (scaleFactor < 1 && scaleFactor > 0.65) {
      element.style.transform = `scale(${scaleFactor})`;
    }
  }
}

// Function to calculate distance between element and mouse position
function calculateDistance(rect, mouseX, mouseY) {
  var elementX = rect.left + rect.width / 2;
  var elementY = rect.top + rect.height / 2;
  var deltaX = mouseX - elementX;
  var deltaY = mouseY - elementY;

  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
}

function dotHoveringEffectsListener(
  data,
  selected_collection_handle,
  image_type = "holistic"
) {
  document.addEventListener("mousemove", (e) =>
    reactToMouse(e, data, selected_collection_handle, image_type)
  );
}

function dotProductEventHandlers(
  product_handle,
  selected_collection_handle,
  image_type = "holistic"
) {
  console.log(product_handle);
  (function () {
    var dot = document.querySelector(
      `.collection--${selected_collection_handle}.${image_type} .dot-${product_handle}`
    );
    var popup = document.querySelector(
      `.collection--${selected_collection_handle}.${image_type} .popup-product-${product_handle}`
    );

    dot.addEventListener("mouseover", function () {
      popup.classList.replace("hidden", "visible");
    });

    popup.addEventListener("mouseleave", function () {
      if (popup.classList.contains("visible")) {
        popup.classList.replace("visible", "hidden");
      }
    });

    dot.addEventListener("mouseleave", function (e) {
      var movedToElement = e.relatedTarget;
      if (!movedToElement.classList.contains("popup")) {
        popup.classList.replace("visible", "hidden");
      }
    });
  })(); // immediate invocation
}

function presentContent(selected_collection_handle, image_type = "holistic") {
  document
    .querySelector(
      `.collection--${selected_collection_handle}.${image_type} .skeleton-card`
    )
    .classList.replace("visible", "hidden");
  document
    .querySelector(
      `.collection--${selected_collection_handle}.${image_type} .section-wrapper`
    )
    .classList.remove("hidden");
}

function suiteCollectionsListPageRoot() {
  var collections = dovr.suite_collections;
  var list = document.querySelector(".suite-sidebar");
  var grid = document.querySelector(".flex-container");
  for (var collection of collections) {
    list.innerHTML =
      list.innerHTML +
      `<li class="suite-list-item"><a class="suite-list-item-link" href="/collections/room-${collection.name
        .toLowerCase()
        .replaceAll(" ", "-")}">${collection.name}</a></li>`;
    grid.innerHTML =
      grid.innerHTML +
      `
      <div class="flex-item">
        <div class="suite-card"> 
          <div class="suite-card-content">
            <a class="suite-card-link" href="/collections/room-${collection.name
              .toLowerCase()
              .replaceAll(" ", "-")}">
              <div class="suite-card-img-wrapper">
                <img src="${collection.images.holistic.desktop}" alt="${
        collection.name
      } - Image" class="suite-card-img">
              </div>
              <div class="suite-card-text">
                <span class="suite-collection">${collection.name}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      `;
  }
}

async function getProductsData(products) {
  var list = [];
  try {
    for (var item of products) {
      var data = await requestProductInfo(item);
      if (data !== undefined) {
        list.push(data);
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    return list;
  }
}

async function suiteCollectionPageRoot(
  collection_name,
  collection_handle,
  section_id
) {
  var selected_collection = collection_name;
  var selected_collection_handle = collection_handle;

  var collections = dovr.suite_collections;

  //CSS for dots
  renderStyleSheetCoordinates(
    collections,
    selected_collection,
    selected_collection_handle
  );

  //Main suite_collections loop
  for (var i = 0; i < collections.length; i++) {
    var collection = collections[i];
    if (collection.name === selected_collection) {
      //Get all products data from Shopify
      var products = await getProductsData(collection.products);
      var image_types = Object.keys(collection.products[0].hotspots);

      //Render each suite room image and its hotspots/products
      for (var image_type of image_types) {
        addShoppableImageSrc(
          collection,
          selected_collection_handle,
          image_type
        );

        if(image_type === "blown_out") {
          await renderHotSpots(
            products,
            selected_collection,
            selected_collection_handle,
            image_type
          );
  
          // Add event listener for mousemove event
          dotHoveringEffectsListener(
            products,
            selected_collection_handle,
            image_type
          );
        }
        //Hide Skeleton and show content
          presentContent(selected_collection_handle, image_type);
      }

      //Add Description Text
      addDescription(collection, section_id);
      break;
    }
  }
}
